import { render, staticRenderFns } from "./_wakeLockButton.vue?vue&type=template&id=3b9b5fde&"
import script from "./_wakeLockButton.vue?vue&type=script&lang=js&"
export * from "./_wakeLockButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\actions-runner\\_work\\red.PandoSites\\red.PandoSites\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3b9b5fde', component.options)
    } else {
      api.reload('3b9b5fde', component.options)
    }
    module.hot.accept("./_wakeLockButton.vue?vue&type=template&id=3b9b5fde&", function () {
      api.rerender('3b9b5fde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "PandoSites.Web/Shared/ActionToolbar/Scripts/Buttons/_wakeLockButton.vue"
export default component.exports